export const ENDPOINTS = {
  SIGN_IN: "/users/tokens/sign_in",
  SIGN_UP: "/users/tokens/sign_up",
  SOCIAL_SIGNING: "/api/v1/users/socials/login",
  UPDATE_USER: "/api/v1/users/profile",
  UPDATE_USER_EMAIL_AS_VERFIED: "/api/v1/users/profile/sign_in_count",
  RESEND_VERIFICATION_EMAIL: "/api/v1/users/profile/resend_verification",
  LOGGGED_IN: "/users/tokens/info",
 GET_ALL_PROPERTIES: (page: number, perPage?: number) => `/api/v1/properties?page=${page}${perPage ? `&per_page=${perPage}` : ""}`,
  UPDATE_NOTIFICATION_PREFERENCE: "api/v1/users/profile/set_preference",
  CREATE_PROPRTIES: "/api/v1/properties",
  PROPERTY_CATEGORY: "/api/v1/property_categories",
  UPDATE_PROPERTIES: "/api/v1/properties",
  AMENITIES_PROPERTIES: "/api/v1/amenities/property",
  HOUSE_RULE: "api/v1/house_rules",
  DELETE_USER: "/api/v1/users",
  GET_ALL_UPDATE_PROPERTY_DETAILS: "/api/v1/properties",
  SEND_EMAIL: "users/password",
  ADD_CREDIT_CARD: "api/v1/credit_cards",
  ADD_PAYPAL: "/api/v1/user_paypal",
  EDIT_PAYPAL: "/api/v1/user_paypal",
  CREATE_CHAT: "api/v1/chats",
  SEND_MESSAGE: (chatId: number) => `/api/v1/chats/${chatId}/messages`,
  GET_MESSAGE: (chatId: number, page: number) =>
    `/api/v1/chats/${chatId}/messages?page=${page}`,
  DELETE_MESSAGE: (chatId: number, messageId: number) =>
    `/api/v1/chats/${chatId}/messages/${messageId}`,
  // CHAT_SEARCH: (query: string) => `/api/v1/chat_search?q=${encodeURIComponent(query)}`,
  ADD_QUERIES: (propertyId: number) =>
    `/api/v1/properties/${propertyId}/booking_queries`,
  SEARCH_PROPERTIES: (query: string) => `/api/v1/properties/search?${query}`,
// In your ENDPOINTS file
  SEARCH_PROPERTIES_BY_LOCATION: (query: string) => `/api/v1/search_by_location?${query}`,
  
  CHAT_SEARCH: (query: string) => `/api/v1/chat_search?q=${query}`,

  BOOKING: "/api/v1/bookings",
  PAYMET_INTENT: "/api/v1/payments/payment_intent",
  PAYMENT_METHODS: "/api/v1/payments/payment_method",
  PAYMENT_SUCCESS: (bookingId: number) => `/api/v1/bookings/${bookingId}`,
  GET_ALL_PROPERTY_TYPE: "/api/v1/property_types",
  GET_ALL_FEATURES_STATUS: "api/v1/features/property",
  GET_TAX: "/api/v1/properties/property_tax",
  ROOM_AMENITIES_PROPERTIES: "/api/v1/amenities/room",
  ROOM_FEATURES_PROPERTIES: "/api/v1/features/room",
  ROOM_BED_TYPE: "api/v1/bed_types",
  ROOM_TYPE: "api/v1/room_types",
  HOST_CHAT_LISTS: (page: number) => `api/v1/chats?page=${page}`,
  STUDENT_CHAT_LISTS: (page: number) => `/api/v1/chats/user_chat?page=${page}`,
  GET_PROPERTY_Listing: (page: number, query: string) =>
    `/api/v1/properties/my_properties?page=${page}&q[title_cont]=${query?.trim()}`,
  BOOKING_DEATAILS: (page: number, query?: string) =>
    `/api/v1/bookings/my_reservation?page=${page}${query ? `&q=${query}` : ""}`,
  GET_BOOKING_DEATAILS: (page: number, query?: string, startDate?: string, endDate?: string) =>
    `/api/v1/bookings?page=${page}${query ? `&q=${query}` : ""}${startDate ? `&start_date=${startDate}` : ""}${endDate ? `&end_date=${endDate}` : ""}`,
  MANAGE_REQUEST_BOOKING: (page: number, query?: string) =>
    `api/v1/bookings/host_request?page=${page}${query ? `&q=${query}` : ""}`,
  MANAGE_QUERIES_BOOKING: (page: number, query?: string) =>
    `/api/v1/booking_queries/host_query?page=${page}${
      query ? `&q=${query}` : ""
    }`,
  GET_BOOKING_QUERIES_DATA: "/api/v1/booking_queries",
  BOOKING_QUERY: (id: number, propertyId: number) =>
    `/api/v1/booking_queries/${id}?property_id=${propertyId}`,
  GET_BOOKING_QUERIES: (page: number, query?: string) =>
    `/api/v1/booking_queries?page=${page}${query ? `&q=${query}` : ""}`,
  HOST_BOOKING_DETAILS: (page: number, query?: string, startDate?: string, endDate?: string) =>
    `/api/v1/bookings/host_booking?page=${page}${query ? `&q=${query}` : ""}${startDate ? `&start_date=${startDate}` : ""}${endDate ? `&end_date=${endDate}` : ""}`,
  GET_CANCILATION_DETAILS: "/api/v1/cancellation_policies",
  UPDATE_PROPERTY_LISTING: "/api/v1/properties",
  DELETEIMAGE: "/api/v1/image_destroy",
  UNREADCOUNT: "api/v1/unread_chat_count",
  REVIEW: (id: number) => `/api/v1/bookings/${id}/reviews`,
  GET_ALL_REVIEW: (id: number) => `/api/v1/properties/${id}/reviews`,
  SIMILAR_PROPERTIES: "/api/v1/properties/similar_property",
  INVOICE: "/api/v1/invoices",
  BOOKING_DETAILS: "/api/v1/bookings",
  POST_FAVORITES: "/api/v1/favorites",
  POST_SHARE: (propertyId: number | string) => `/api/v1/properties/${propertyId}/shares`,
  GET_FAVORITES: (page: number) => `/api/v1/favorites?page=${page}`,
  Contact_US: "/api/v1/contact_us",
  All_blogs: "/api/v1/blogs",
  GET_BLOGS: "/api/v1/blogs",
  POST_COMMENTS: (slug: string) => `/api/v1/blogs/${slug}/comments`,
  EXCLUSIVE_PROPERTIS: "/api/v1/exclusive_properties",
  FEATURES_PROPERTY: "/api/v1/feature_properties",
  NEIGHBORHOODS: "/api/v1/neighborhoods",
  GETALLREVIEWS: "/api/v1/homepage/reviews",
  CITY_PROPERTIES: (query: string) => `/api/v1/city_search?${query}`,
  GOOGLE_REVIEWS: (placeId: string) => `/api/v1/google-reviews?placeId=${placeId}`,
   GET_ALL_EXPERIENCES: "/api/v1/experiences",
  GET_EXPERIENCE_DETAIL: (slug: string) => `/api/v1/experiences/${slug}`,
  LEGACY_BOOKINGS: "/api/v1/legacy_bookings",
  LEGACY_REVIEWS: (propertyName: string) => 
  `/api/v1/legacy_reviews?property_name=${encodeURIComponent(propertyName)}`,
 CHECK_DUPLICATE_BOOKING: (propertyId: string, roomId: number | undefined, checkIn: string, checkOut: string) => 
  `/api/v1/check_booking_duplicate?property_id=${propertyId}${roomId ? `&room_id=${roomId}` : ""}&check_in_date=${checkIn}&check_out_date=${checkOut}`,
 LAST_ROOMS_AVAILABLE: (startDate: string, endDate: string, occupancyThreshold?: number) =>
  `/api/v1/last_rooms_available?start_date=${startDate}&end_date=${endDate}${occupancyThreshold ? `&occupancy_threshold=${occupancyThreshold}` : ""}`,
 BOOKING_ELIGIBILITY: "/api/v1/experience_bookings/eligibility",
 CREATE_EXPERIENCE_BOOKING: "/api/v1/experience_bookings",
 GET_ROOM_LINK: (token: string, query?: string) =>
  `/api/v1/room_links/${encodeURIComponent(token)}${query ? `?${query}` : ""}`,

  GET_PROPERTY_ROOMS: (slug: string, query?: string) =>
  `/api/v1/property_rooms/${encodeURIComponent(slug)}${query ? `?${query}` : ""}`,

};
